module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp123_5010.b9dd6e9c.png";